import {
  SET_USER_PREFERENCE,
} from '../actions/userPreferences';

export const initialState = {};

export default function userPreferences(state = initialState, action) {
  switch (action.type) {
    case SET_USER_PREFERENCE: {
      return { ...state, [action.preference]: action.value };
    }
    default:
      return state;
  }
}
